var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var OutlierConfig_1;
import { ToolType } from '@symon-ai/wisepipe-base-pipe';
import { JSON, JsonDiscriminatorValue, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { BaseOutlierConfig } from './baseOutlierConfig';
import { ToolCategories } from './toolCategories';
import { ToolConfigInfo } from './toolConfigInfo';
import { ToolValidationResult } from './validation/toolValidationResult';
import { validateSourceWithDetail } from './validation/validateHelper';
import { outlierConfigSchemaValidation } from '../validations.generated';
export const outlierConfigSchema = {
    $id: 'urn:wisepipe-common-pipe:OutlierConfig',
    type: 'object',
    properties: {
        options: { type: 'integer', minimum: 1, maximum: 11 },
        contamination: { type: 'number', minimum: 0, maximum: 0.5 },
        threshold: { type: 'number', minimum: 0, maximum: 1 },
        probaColumn: { type: 'string', minLength: 1 }
    },
    // required: ['options'] // Uncomment this after ui is changed to send the data over
    required: []
};
let OutlierConfig = OutlierConfig_1 = class OutlierConfig extends BaseOutlierConfig {
    constructor(column, newColumn, options, contamination, threshold, probaColumn, groupByColumns, customFormats) {
        super(ToolType.OUTLIER, column, newColumn, groupByColumns, customFormats);
        if (contamination !== undefined)
            this.contamination = contamination;
        if (threshold !== undefined)
            this.threshold = threshold;
        if (options !== undefined)
            this.options = options;
        if (probaColumn !== undefined)
            this.probaColumn = probaColumn;
        JSON.validate(this, OutlierConfig_1);
    }
    static get info() {
        return new ToolConfigInfo(ToolType.OUTLIER.split('_')
            .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
            .join(' '), [ToolCategories.CALCULATE], this.ins, this.outs, [
            'anomaly',
            'z score outlier',
            'iqr outlier',
            'abod outlier',
            'cblof outlier',
            'cof outlier',
            'hbos outlier',
            'k-nn outlier',
            'one class svm outlier',
            'isolation forest outlier',
            'subspace outlier',
            'pca outlier',
            'so-gaal outlier',
            'mo-gaal outlier'
        ], false);
    }
    getOutput(iConfigHelper, ins) {
        return this.getOutputForOutlier(ins, true, this.probaColumn);
    }
    isValidForCalc(iConfigHelper, scope) {
        const toolValidationResult = this.getToolValidationResult(iConfigHelper, scope);
        return toolValidationResult.validationState;
    }
    getToolValidationResult(iConfigHelper, scope) {
        const source = scope.schemas.at(this.in);
        if (!source) {
            return ToolValidationResult.getMissingSourceColumnsResult();
        }
        const inputs = new Map([[this.column, ['number']]]);
        this.addGroupByToInputs(inputs, this.groupByColumns);
        const newColumnName = this.newColumn === undefined ? 'Outlier' : this.newColumn;
        const probaColumnName = this.probaColumn === undefined ? `${newColumnName} Probability` : this.probaColumn;
        const outputs = [newColumnName, probaColumnName];
        const sourceValidationResult = validateSourceWithDetail(source, inputs, outputs);
        return ToolValidationResult.getResultFromSourceValidation(sourceValidationResult);
    }
};
OutlierConfig = OutlierConfig_1 = __decorate([
    JsonSchemaV2(outlierConfigSchema, outlierConfigSchemaValidation),
    JsonDiscriminatorValue(ToolType.OUTLIER)
], OutlierConfig);
export { OutlierConfig };
//# sourceMappingURL=outlierConfig.js.map